/**
 * Taskpane env / dev-mode flags.
 */

// Webpack DefinePlugin uses JSON.stringify(dev) → inlines boolean `true` / `false`, not the string "true".
declare const __DEV_MODE__: boolean | string | undefined

export function isDevMode(): boolean {
	if (
		typeof window !== "undefined" &&
		window.location.search.includes("dev=1")
	) {
		return true
	}
	if (typeof __DEV_MODE__ === "boolean") {
		return __DEV_MODE__
	}
	return __DEV_MODE__ === "true"
}
